import React, { useEffect, useState } from 'react';
import { Box, Text, Heading, VStack } from '@chakra-ui/react';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

function TermsOfService() {
  const id = '94944409631072256';

  const [blogData, setBlogData] = useState({});

  const { title, content, updatedTime } = blogData;

  useEffect(() => {
    api
      .get(`${API_BASE}/api/blog/find-by-id?blogId=${id}`)
      .then((res) => {
        // console.log('============= fetch blog by slug details response: ', res);
        if (res.status == 200) {
          setBlogData(res.data);
        }
      })
      .catch(() =>
        console.log('failed to fetch blog details data, slug: ', id)
      );
  }, []);

  return (
    <Box
      maxW="800px"
      mx="auto"
      mt={20}
      mb={8}
      p={6}
      borderWidth="1px"
      borderRadius="lg"
      boxShadow="md"
    >
      <VStack align="start" spacing={4}>
        {/* Blog Title */}
        <Heading as="h1" size="lg">
          {title}
        </Heading>

        {/* Date */}
        <Text fontSize="sm" color="gray.600">
          {new Date(updatedTime).toLocaleDateString()}
        </Text>

        {/* Blog Content */}
        <Box
          fontSize="lg"
          lineHeight="tall"
          whiteSpace="pre-wrap"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </VStack>
    </Box>
  );
}

export default TermsOfService;
